import api from "../../../utils/api";

// Add Project
const addProject = async (projectData) => {
  const response = await api.post("projects", projectData);
  return response.data;
};

const getProjects = async (page = 1, limit = 15) => {
  try {
    const response = await api.get("projects", {
      params: {
        page,
        limit,
      },
    });
    return response.data;
  } catch (error) {
    throw error;
  }
};

const getProject = async (handle) => {
  const response = await api.post("projects/project", handle);
  return response.data.project;
};

const getSearchProjects = async (inputValue) => {
  const response = await api.post("projects/search", inputValue);
  return response.data.projects;
};

const projectsService = {
  addProject,
  getProjects,
  getSearchProjects,
  getProject,
};

export default projectsService;
